module.exports = __webpack_public_path__ + "static/img/边14.cad2297.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边14.png
// module id = pDoY
// module chunks = 2